import { render, staticRenderFns } from "./AccountDetails.vue?vue&type=template&id=17c3d0f4&"
import script from "./AccountDetails.vue?vue&type=script&lang=ts&"
export * from "./AccountDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports